module.exports = __webpack_public_path__ + "static/media/home-opener-illustration2.177cd2b0.png";